import { PageLayoutStyled } from "./PageLayout.styled";

export const PageLayout = ({
    children,
    isFullScreenLayout,
}: {
    children: any;
    isFullScreenLayout: boolean;
}) => {
    return (
        <PageLayoutStyled isFullScreenLayout={isFullScreenLayout}>
            {children}
        </PageLayoutStyled>
    );
};
